import { WithdrawalsReceiveSetExchangeRatesReducer } from './types';

export const withdrawalsReceiveSetExchangeRatesReducer: WithdrawalsReceiveSetExchangeRatesReducer =
  (state, action) => {
    const { items } = action.payload;

    const { withdrawalsExchangeRates } = state;

    if (!withdrawalsExchangeRates) {
      return state;
    }

    return {
      ...state,
      withdrawalsExchangeRates: {
        ...withdrawalsExchangeRates,
        items,
      },
      withdrawalsExchangeRatesProcessedItems: items,
    };
  };
